import { Action, Dispatch } from "redux";
import initialState from "../initialState";
import { NotificationActions } from "./notification/notification-actions";
import { AppDispatch } from "./index";
import { getApi } from "../api/ApiProvider";

export enum BranchActionTypes {
  FETCH_REQUEST = "[BRANCH][LIST] Request",
  FETCH_RESPONSE = "[BRANCH][LIST] Response",
  FETCH_ERROR = "[BRANCH][ERROR] Error",

  ADD_REQUEST = "[BRANCH][ADD] Request",
  ADD_RESPONSE = "[BRANCH][ADD] Response",
  ADD_ERROR = "[BRANCH][ADD] Error",

  DISABLE_REQUEST = "[BRANCH][DISABLE] Request",
  DISABLE_RESPONSE = "[BRANCH][DISABLE] Response",
  DISABLE_ERROR = "[BRANCH][DISABLE] Error",

  ACTIVATE_REQUEST = "[BRANCH][ACTIVATE] Request",
  ACTIVATE_RESPONSE = "[BRANCH][ACTIVATE] Response",
  ACTIVATE_ERROR = "[BRANCH][ACTIVATE] Error",
}

export interface IBranchStore {
  data: {
    fetching: boolean;
    error?: any;
    data?: any;
  };
  add: {
    fetching: boolean;
    error?: any;
    data?: any;
  };
}

export default (
  state: IBranchStore = initialState.branch,
  action?: Action<BranchActionTypes> & { payload: any }
) => {
  if (!action) {
    return state;
  }

  switch (action.type) {
    case BranchActionTypes.FETCH_REQUEST:
      return {
        ...state,
        data: {
          fetching: true,
          error: null,
          data: null,
        },
      };

    case BranchActionTypes.FETCH_RESPONSE:
      return {
        ...state,
        data: {
          fetching: false,
          data: action.payload,
          error: null,
        },
      };

    case BranchActionTypes.FETCH_ERROR:
      return {
        ...state,
        data: {
          fetching: false,
          data: null,
          error: action.payload,
        },
      };

    case BranchActionTypes.ADD_REQUEST:
      return {
        ...state,
        add: { fetching: true },
      };
    case BranchActionTypes.ADD_RESPONSE:
      if (state.data && state.data.data) {
        return {
          ...state,
          data: {
            data: state.data.data.concat(action.payload),
            fetching: false,
          },
          add: { fetching: false, data: action.payload },
        };
      }
      return {
        ...state,
        add: { fetching: false, data: action.payload },
      };
    case BranchActionTypes.ADD_ERROR:
      return {
        ...state,
        add: { fetching: false, error: action.payload },
      };

    default:
      return state;
  }
};

export class BranchActions {
  save(data: any) {
    return (dispatch: AppDispatch) => {
      const notif = new NotificationActions();

      dispatch({ type: BranchActionTypes.ADD_REQUEST });

      getApi()
        .branch()
        .save(data)
        .then(() => {
          dispatch(notif.addSuccess("Sucursal", "Sucursal guardada"));
          dispatch(this.fetch());
          // dispatch({ type: BranchActionTypes.ADD_RESPONSE, payload: response });
        })
        .catch((err) => {
          dispatch(
            notif.addError(
              "Sucursal",
              "Inconvenientes al guardar. Verifique sus datos"
            )
          );
          dispatch({ type: BranchActionTypes.ADD_ERROR, payload: err });
        });
    };
  }

  disable(data: any, companyId: number) {
    return (dispatch: AppDispatch) => {
      dispatch({ type: BranchActionTypes.DISABLE_REQUEST });
      getApi()
        .branch()
        .disable(data.id)
        .then(() => {
          dispatch({ type: BranchActionTypes.DISABLE_RESPONSE, payload: data });
          dispatch(this.fetch());
        })
        .catch((err) => {
          dispatch({ type: BranchActionTypes.DISABLE_ERROR, payload: err });
        });
    };
  }

  activate(data: any, companyId: number) {
    return (dispatch: AppDispatch) => {
      dispatch({ type: BranchActionTypes.ACTIVATE_REQUEST });
      getApi()
        .branch()
        .activate(data.id)
        .then(() => {
          dispatch({
            type: BranchActionTypes.ACTIVATE_RESPONSE,
            payload: data,
          });
          dispatch(this.fetch());
        })
        .catch((err) => {
          dispatch({ type: BranchActionTypes.ACTIVATE_ERROR, payload: err });
        });
    };
  }

  fetch() {
    return (dispatch: Dispatch) => {
      dispatch({ type: BranchActionTypes.FETCH_REQUEST });
      getApi()
        .branch()
        .listAllBranchesAdmin()
        .then((data) => {
          dispatch({ type: BranchActionTypes.FETCH_RESPONSE, payload: data });
        })
        .catch((err) => {
          dispatch({ type: BranchActionTypes.FETCH_ERROR, payload: err });
        });
    };
  }
}



// WEBPACK FOOTER //
// ./src/store/branch.ts